var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil14 {fill:none}\n    .fil8 {fill:#296424}\n    .fil6 {fill:#33691E}\n    .fil3 {fill:#38262C}\n    .fil0 {fill:#3E2723}\n    .fil9 {fill:#7EB45E}\n    .fil7 {fill:#9CCC65}\n    .fil5 {fill:#D47C0F}\n    .fil4 {fill:#D49144}\n    .fil12 {fill:#E34200}\n    .fil10 {fill:#E65100}\n    .fil13 {fill:#EF6713}\n    .fil11 {fill:#F57F17}\n    .fil2 {fill:#FF9100}\n    .fil1 {fill:#FFAB40}\n   >\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    x: 256,
    y: 320,
    width: 416,
    height: 1408,
    rx: 27,
    ry: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 256,
    y: 565,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 256,
    y: 1404,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 256,
    y: 1298,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 464,
    cy: 892,
    r: 103
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 353,
    y: 1024,
    width: 223,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M283 320l181 0 0 1408 -181 0c-15,0 -27,-12 -27,-27l0 -1353c0,-15 12,-27 27,-27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "256,565 464,565 464,618 256,618 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "256,1404 464,1404 464,1457 256,1457 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "256,1298 464,1298 464,1351 256,1351 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M464 789l0 0 0 205 0 0c-57,0 -103,-46 -103,-103 0,-57 46,-103 103,-103z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "353,1024 464,1024 464,1038 353,1038 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "_220504008"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil6",
    x: 731,
    y: 320,
    width: 416,
    height: 1408,
    rx: 27,
    ry: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 731,
    y: 565,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 731,
    y: 1404,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 731,
    y: 1298,
    width: 416,
    height: 53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil7",
    cx: 939,
    cy: 892,
    r: 103
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 828,
    y: 1024,
    width: 223,
    height: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220502880"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M759 320l181 0 0 1408 -181 0c-15,0 -27,-12 -27,-27l0 -1353c0,-15 12,-27 27,-27z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "731,565 939,565 939,618 731,618 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "731,1404 939,1404 939,1457 731,1457 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "731,1298 939,1298 939,1351 731,1351 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M939 789l0 0 0 205 0 0c-57,0 -103,-46 -103,-103 0,-57 46,-103 103,-103z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "828,1024 939,1024 939,1038 828,1038 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_220502088"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil10",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1203.38 352.215)",
    width: 454,
    height: 1536,
    rx: 27,
    ry: 27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil11",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1234.52 594.83)",
    width: 454,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil11",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1341.42 1427.67)",
    width: 454,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil11",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1327.93 1322.54)",
    width: 454,
    height: 58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil11",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1482.52 893.067)",
    r: 112
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil11",
    transform: "matrix(0.909203 -0.116707 0.116707 0.909203 1388.97 1038.16)",
    width: 243,
    height: 15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_220500816"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M1231 349l180 -23 179 1397 -179 23c-15,2 -29,-9 -31,-24l-172 -1342c-2,-15 9,-29 24,-31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fil13",
    points: "1235,595 1442,568 1448,621 1241,647 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil13",
    points: "1341,1428 1548,1401 1555,1454 1348,1480 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil13",
    points: "1328,1323 1535,1296 1541,1349 1335,1375 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M1469 791l1 0 26 204 -1 0c-56,7 -108,-33 -115,-89 -7,-56 33,-108 89,-115z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil13",
    points: "1389,1038 1500,1024 1502,1037 1391,1052 "
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "fil14",
    width: 2048,
    height: 2048
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLib);
export default __webpack_public_path__ + "static/media/lib.cfb0c6fc585e4f5d8b3b9f30cc81431b.svg";
export { ForwardRef as ReactComponent };